<!-- 登录页 -->
<template>
    <div class="login">
        <video class="login-video-bg" id="video" src="../assets/img/lawcase.mp4" autoplay="autoplay" muted="muted"
            loop="loop"></video>
        <div class="login-form-panel">
            <div class="login-form-header">
                <div class="login-form-logo">
                    <img src="../assets/img/logo20.png" alt="">
                </div>
            </div>
            <div class="login-title">
                执法依据智能应用系统
            </div>
            <div class="login-form-content">
                <div class="login-form-tabs">
                    用户登录
                </div>
                <div class="login-form-container">
                    <Form ref="Form" :model="Form" :rules="Rule" @keyup.enter.native="submitLogin('Form')">
                        <FormItem prop="user">
                            <i class="icon-user"></i>
                            <Input type="text" v-model="Form.username" placeholder="请输入用户名">
                            </Input>
                        </FormItem>
                        <FormItem prop="password">
                            <i class="icon-password"></i>
                            <Input type="password" v-model="Form.password" placeholder="请输入密码">
                            </Input>
                        </FormItem>
                        <p class="tips">如无账号，请致电 13911386635，免费获取测试账号</p>
                        <FormItem class="btn-login">
                            <Button type="primary" @click="submitLogin('Form')">登录</Button>
                        </FormItem>
                    </Form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { login, reqArea } from '@/api/index'

    export default {
        name: 'Login',
        components: {

        },
        props: {
            // 小驼峰命名
            demoInfo: {
                type: String,
                default() {
                    return 'login-demo'
                }
            }
        },
        data() {
            return {
                Form: {
                    username: '',
                    password: ''
                },
                Rule: {
                    username: [
                        { required: true, message: '请输入用户名', trigger: 'blur' }
                    ],
                    password: [
                        { required: true, message: '请输入密码', trigger: 'blur' },
                        { type: 'string', min: 6, message: '密码长度不能小于6位', trigger: 'blur' }
                    ]
                }
            }
        },
        computed: {

        },
        watch: {

        },
        created() {

        },
        mounted() {
          // 校验是否为v6携带参数进入系统
          if (Object.keys(this.$route.query).length > 0) {
            // 有参数模拟登录并获取权限
            if (this.$route.query.auth) {
              login({
                  username: '',
                  password: '',
                  auth: this.$route.query.auth
              }).then(res => {
                  if (res.ok) {
                      this.setStore('Authorization', res.data);
                      this.setStore('userInfo', res.dataMap);
                      // this.$Message.success('登录成功!');
                      this.$router.push({ name: 'Home', params: this.$route.query });
                  } else {
                      this.$Message.error('用户不存在或密码错误!');
                  }
              });
            } else {
              this.setStore('Authorization', '');
              this.setStore('userInfo', '');
              this.$router.push({ path: '/' });
            }
          }
        },
        destoryed() {

        },
        methods: {
            submitLogin(name) {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        login(this.Form).then(res => {
                            if (res.ok) {
                                this.setStore('Authorization', res.data);
                                this.setStore('userInfo', res.dataMap);
                                this.$Message.success('登录成功!');
                                this.$router.push({ path: '/home' });
                            } else {
                                this.$Message.error('用户不存在或密码错误!');
                            }
                        });
                    } else {
                        this.$Message.error('登录失败!');
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .login-video-bg {
        overflow: hidden;
        position: fixed;
        top: 50%;
        left: 50%;
        min-width: 100%;
        min-height: 100%;
        width: auto;
        height: auto;
        transform: translateX(-50%) translateY(-50%);
        /* background: rgba(151, 177, 177, 0.3); */
    }

    .login-form-panel {
        display: flex;
        flex-direction: column;
        justify-content: center;
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        z-index: 2;
        margin: auto;
        padding: 50px;
        width: 470px;
        height: 560px;
        /* height: 60%; */
        border-radius: 3px;
        background-color: rgba(33, 53, 97, 0.8);
        /* background-color: rgba(9, 18, 43, 0.3); */
    }

    .login-form-header {
        /* flex: 1 1 auto; */
        display: flex;
        flex-direction: column;
        /* justify-content: flex-end; */
        padding-bottom: 20px;
        font-size: 32px;
        font-weight: bolder;
        color: #fff;
    }

    .login-form-logo {
        width: 50%;
    }

    .login-form-logo img {
        width: 100%;
    }

    .login-form-content {
        flex: 2 1 auto;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        padding-top: 60px;
    }

    .login-form-tabs {
        color: #fff;
        margin-bottom: 26px;
    }

    .login-title {
        font-size: 26px;
        font-weight: 100;
        color: #fff;
    }

    .icon-user {
        position: absolute;
        left: 12px;
        top: 9px;
        z-index: 1;
        width: 18px;
        height: 18px;
        background: url(../assets/img/icon-user.png) no-repeat 0 0;
    }

    .icon-password {
        position: absolute;
        left: 12px;
        top: 9px;
        z-index: 1;
        width: 18px;
        height: 18px;
        background: url(../assets/img/icon-password.png) no-repeat 0 0;
    }

    .btn-login {
        margin-top: 26px;
    }

    .tips {
        margin: 28px 0 14px;
        font-size: 14px;
        text-align: center;
        color: #f00;
    }
</style>